<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Dashboard</h1>
      </template>
      <template #actions>
        <page-header-action
          tag="form-button"
          :indicator="indicator"
          @clicked="sendToCreateView"
          v-if="hasAccessToFnol && !isReadonly()"
        >
          Create FNOL
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-3">
        <div
          class="widget widget-primary clickable"
          v-on:click="goToFirstNoticeOfLoss"
        >
          <div class="widget-label">FNOL</div>
          <div class="widget-value" v-text="first_notice_of_loss"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div
          class="widget widget-primary clickable"
          v-on:click="goToDeployment"
        >
          <div class="widget-label">Deployment</div>
          <div class="widget-value" v-text="deployment"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div
          class="widget widget-primary clickable"
          v-on:click="goToClaimMonitoring"
        >
          <div class="widget-label">Claim Monitoring</div>
          <div class="widget-value" v-text="hire_monitoring"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="widget widget-primary clickable" v-on:click="goToRecovery">
          <div class="widget-label">Recovery</div>
          <div class="widget-value" v-text="recovery"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <template v-if="hasPermission('dashboards.diaries')">
          <div class="card mb-3">
            <div class="card-header">
              <h4 class="card-title flex-title">
                <span>
                  Diary Dates
                </span>
                <span> Total - {{ paginator_data?.total }} </span>
              </h4>
            </div>

            <div class="card-header">
              <div style="width: 100%; margin: 0;">
                <label for="handler_id" style="margin-top: 0;">Handler</label>

                <select
                  name="handler_id"
                  id="handler_id"
                  class="form-control"
                  :value="filters.handler_id"
                  @change="setHandler($event.target.value)"
                >
                  <option value="">All Handlers</option>
                  <option
                    :key="index"
                    :value="handler.id"
                    v-for="(handler, index) in handlers"
                  >
                    {{ handler.full_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="loading-overlay" v-if="loading"></div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Diary Date</th>
                    <th>
                      Handler
                    </th>
                    <th>Claim Reference</th>
                    <th>Client Name</th>
                    <th>Stage</th>
                    <th>Next Step</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody v-if="diaries.length">
                  <tr v-bind:key="index" v-for="(diary, index) in diaries">
                    <td>
                      {{
                        diary?.date_time ? formatDate(diary) : 'Not Provided'
                      }}
                    </td>
                    <td>
                      {{
                        diary.user?.full_name ||
                          diary.incident?.handler?.full_name ||
                          diary.incident?.author?.full_name ||
                          'Not Assigned'
                      }}
                    </td>
                    <td>
                      {{
                        diary.incident?.source?.claim_reference ||
                          'Not Provided'
                      }}
                    </td>
                    <td>
                      {{ diary.incident?.client?.full_name || 'Not Provided' }}
                    </td>
                    <td>
                      {{ diary.incident?.stage?.label || 'Not Provided' }}
                    </td>
                    <td>
                      {{ diary.title || 'Not Provided' }}
                    </td>
                    <td class="text-right">
                      <button
                        class="btn btn-primary"
                        v-on:click.prevent="viewIncident(diary)"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="!diaries.length">
                  <tr>
                    <td colspan="10" class="text-center">
                      There are currently no outstanding diary entries for today
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer text-right" v-show="showPagination">
              <pagination
                :data="paginator_data"
                v-on:updateResults="getDiaries"
              ></pagination>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header">
              <h4 class="card-title flex-title">
                <span>
                  Claims Without An Active Diary
                </span>
                <span>
                  Total - {{ claimsWithoutActiveDiaryPaginator?.total }}
                </span>
              </h4>
            </div>

            <div class="card-header">
              <div style="width: 100%; margin: 0;">
                <label for="handler_id" style="margin-top: 0;">Handler</label>

                <select
                  name="handler_id"
                  id="handler_id"
                  class="form-control"
                  :value="claimsWithoutActiveDiaryFilters.handler_id"
                  @change="
                    setClaimsWithoutActiveDiaryHandler($event.target.value)
                  "
                >
                  <option value="">All Handlers</option>
                  <option
                    :key="index"
                    :value="handler.id"
                    v-for="(handler, index) in handlers"
                  >
                    {{ handler.full_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="loading-overlay" v-if="loading"></div>

            <div class="table-responsive">
              <table class="table" v-if="claimsWithoutActiveDiary.length">
                <thead>
                  <tr>
                    <th>Handler</th>
                    <th>Claim Reference</th>
                    <th>Client Name</th>
                    <th>Stage</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-bind:key="index"
                    v-for="(claim, index) in claimsWithoutActiveDiary"
                  >
                    <td>
                      {{
                        claim.handler?.full_name ||
                          claim.author?.full_name ||
                          'Not Assigned'
                      }}
                    </td>
                    <td>
                      {{ claim.source?.claim_reference || 'Not Provided' }}
                    </td>
                    <td>
                      {{ claim.client?.full_name || 'Not Provided' }}
                    </td>
                    <td>
                      {{ claim.stage?.label || 'Not Provided' }}
                    </td>
                    <td class="text-right">
                      <button
                        class="btn btn-primary"
                        v-on:click.prevent="viewClaimWithoutDiary(claim)"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table" v-if="!claimsWithoutActiveDiary.length">
                <tr>
                  <td colspan="5" class="text-center">
                    There are currently no claims without an active diary
                  </td>
                </tr>
              </table>
            </div>
            <div class="card-footer text-right" v-show="showPagination">
              <pagination
                :data="claimsWithoutActiveDiaryPaginator"
                v-on:updateResults="getClaimsWithoutActiveDiary"
              ></pagination>
            </div>
          </div>
        </template>

        <div class="card mb-3" v-if="hasPermission('dashboards.mot')">
          <div class="card-header">
            <h4 class="card-title flex-title">
              <span>
                MOT Report
              </span>
              <span>
                Total - {{ vehiclesWithMotExpiringPaginator?.total }}
              </span>
            </h4>
          </div>

          <div class="loading-overlay" v-if="loading"></div>

          <div class="table-responsive">
            <table class="table" v-if="vehiclesWithMotExpiring.length">
              <thead>
                <tr>
                  <th>Registration</th>
                  <th>MOT Expiry</th>
                  <th>MOT Status</th>
                  <th>Vehicle Group</th>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Transmission</th>
                  <th>Hire Site</th>
                  <th>Status</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-bind:key="index"
                  v-for="(vehicle, index) in vehiclesWithMotExpiring"
                >
                  <td v-text="vehicle.registration"></td>
                  <td>{{ vehicle.mot_expires_at | dateFormat }}</td>
                  <td :class="getMotStatusClass(vehicle.mot_expires_at)">
                    {{ getMotStatus(vehicle.mot_expires_at) }}
                  </td>
                  <td>{{ vehicle.group?.name }}</td>
                  <td>{{ vehicle | make }}</td>
                  <td v-text="vehicle.model"></td>
                  <td>{{ vehicle.transmission?.label || 'Not Selected' }}</td>
                  <td>{{ vehicle.hire_site?.name }}</td>
                  <td>{{ vehicle.status?.label }}</td>
                  <td class="text-right">
                    <button
                      class="btn btn-primary"
                      v-on:click.prevent="viewVehicleWithMotExpiring(vehicle)"
                    >
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table" v-if="!vehiclesWithMotExpiring.length">
              <tr>
                <td colspan="5" class="text-center">
                  There are currently no vehicle with expiring MOT.
                </td>
              </tr>
            </table>
          </div>
          <div class="card-footer text-right" v-show="showVehiclePagination">
            <pagination
              :data="vehiclesWithMotExpiringPaginator"
              v-on:updateResults="getVehiclesWithMotExpiring"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Modules/Shared/PageHeader.vue';
import PageHeaderAction from './../Modules/Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  data() {
    return {
      first_notice_of_loss: 0,
      deployment: 0,
      recovery: 0,
      hire_monitoring: 0,
      diaries: [],
      paginator_data: {},
      claimsWithoutActiveDiary: [],
      claimsWithoutActiveDiaryPaginator: {},
      vehiclesWithMotExpiringPaginator: {},
      vehiclesWithMotExpiring: [],
      filters: {
        handler_id: null,
        completed: 0
      },
      claimsWithoutActiveDiaryFilters: {
        handler_id: null
      },
      loading: false,
      indicator: false
    };
  },

  computed: {
    hasAccessToFnol() {
      return this.hasModule('first_notice_of_loss');
    },

    hasAccessToDeployment() {
      return this.hasModule('deployment');
    },

    hasAccessToRecovery() {
      return this.hasModule('recovery');
    },

    handlers() {
      return this.$store.getters['ClaimHandlers/all'];
    },

    showPagination() {
      return (
        this.paginator_data.next_page_url || this.paginator_data.prev_page_url
      );
    },

    showVehiclePagination() {
      return (
        this.vehiclesWithMotExpiringPaginator.next_page_url ||
        this.vehiclesWithMotExpiringPaginator.prev_page_url
      );
    },

    user() {
      return this.$store.getters.user;
    }
  },

  mounted() {
    this.$store.commit('ClaimHandlers/retrieve');

    this.setHandlerFilter(this.user);

    this.getFigures();
    this.getDiaries();
    this.getClaimsWithoutActiveDiary();
    this.getVehiclesWithMotExpiring();
  },

  filters: {
    make(vehicle) {
      if (vehicle.make) {
        return vehicle.make.label;
      }

      return 'Not Provided';
    },
    dateFormat(value) {
      if (value) {
        return window.DateManager.format(value);
      }

      return null;
    }
  },

  methods: {
    goToFirstNoticeOfLoss() {
      this.route('/first-notice-of-loss');
    },

    goToDeployment() {
      this.route('/deployment');
    },

    goToClaimMonitoring() {
      this.route('/claim-monitoring');
    },

    goToRecovery() {
      this.route('/recovery');
    },

    getFigures() {
      this.findFigures('first_notice_of_loss');
      this.findFigures('deployment');
      this.findFigures('hire_monitoring');
      this.findFigures('recovery');
    },

    findFigures(category) {
      window.Ajax.get(`/incidents/count?type=${category}`)
        .then(response => {
          this[category] = response.data.count;
        })
        .catch(error => {});
    },

    getDiaries(url) {
      if (this.user.id) {
        if (!url) {
          url = `/diary?page=1&per_page=${this.perPage}`;
        }

        Object.keys(this.filters).forEach(key => {
          url = `${url}&filter[${key}]=${this.filters[key]}`;
        });

        window.Ajax.get(url)
          .then(response => {
            this.paginator_data = response.data;
            this.diaries = response.data.data;
          })
          .catch(error => {});
      }
    },

    getClaimsWithoutActiveDiary(url) {
      if (this.user.id) {
        if (!url) {
          url = `/incidents?page=1&per_page=${this.perPage}`;
        }

        url = `${url}&filter[incomplete]=1&filter[without_active_diary]=1`;

        Object.keys(this.claimsWithoutActiveDiaryFilters).forEach(key => {
          url = `${url}&filter[${key}]=${this.claimsWithoutActiveDiaryFilters[key]}`;
        });

        window.Ajax.get(url)
          .then(response => {
            this.claimsWithoutActiveDiaryPaginator = response.data;
            this.claimsWithoutActiveDiary = response.data.data;
          })
          .catch(error => {});
      }
    },

    getVehiclesWithMotExpiring(url) {
      if (this.user.id) {
        if (!url) {
          let identifier = this.user.tenant?.identifier;

          if (identifier) {
            url = `/fleet/${identifier}?per_page=${this.perPage}`;
          }
        }

        url = `${url}&sort=mot_expires_at&filter[not_defleeted]=1&filter[mot_expiring]=1`;

        window.Ajax.get(url)
          .then(response => {
            this.vehiclesWithMotExpiringPaginator = response.data;
            this.vehiclesWithMotExpiring = response.data.data;
          })
          .catch(error => {});
      }
    },

    setHandler(handlerId) {
      this.filters.handler_id = handlerId;

      this.getDiaries();
    },

    setClaimsWithoutActiveDiaryHandler(handlerId) {
      this.claimsWithoutActiveDiaryFilters.handler_id = handlerId;

      this.getClaimsWithoutActiveDiary();
    },

    setHandlerFilter(user) {
      this.filters.handler_id = user.id;
    },

    sendToCreateView() {
      this.indicator = true;
      window.Ajax.post('/incidents', {})
        .then(response => {
          this.indicator = false;
          this.sendToRoute(response.data.identifier);
        })
        .catch(error => {
          this.indicator = false;
          window.toastify.error(
            'Sorry, there was an issue creating the first notice of loss'
          );
        });
    },

    sendToRoute(identifier) {
      this.route(`/first-notice-of-loss/${identifier}`);
    },

    viewIncident(diary) {
      if (
        this.getIncidentStatusById(diary.incident?.status_id).name ===
        'rejected'
      ) {
        this.route(`/rejected/${diary.incident.identifier}`);
      } else {
        this.route(
          diary.incident ? this.incidentUrl(diary.incident) : diary.url
        );
      }
    },

    viewClaimWithoutDiary(result) {
      this.route(this.incidentUrl(result));
    },

    viewVehicleWithMotExpiring(vehicle) {
      this.route(`/fleet/${vehicle.identifier}`);
    },

    formatDate(diary) {
      return window.DateManager.format(diary.date_time);
    },

    getMotStatus(motExpiresAt) {
      const motDate = new Date(motExpiresAt);
      const timeDiff = motDate.getTime() - new Date().getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (daysDiff < 0) {
        return 'Mot expired';
      } else if (daysDiff <= 30) {
        return 'Expiring soon';
      }
    },

    getMotStatusClass(motExpiresAt) {
      const status = this.getMotStatus(motExpiresAt);
      if (status === 'Mot expired') {
        return 'text-danger';
      } else if (status === 'Expiring soon') {
        return 'text-warning';
      }
    }
  },

  watch: {
    user(user) {
      this.setHandlerFilter(user);

      this.getDiaries();
      this.getClaimsWithoutActiveDiary();
      this.getVehiclesWithMotExpiring();
    }
  }
};
</script>

<style>
.flex-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
